import { categories } from '@features/Cashback/Calculator/constants/categories';
import { type CalculationOutputCategory } from '@features/Cashback/Calculator/types';

import { calcEarnings } from '../../utils/createCalcOutput';
import { type CategoryFields } from '../types';

// median discount of all partner retailers by category
const medianCategoryDiscounts = {
  cbcCalcGroceries: 0.015,
  cbcCalcTransportFuel: 0.015,
  cbcCalcFashionBeauty: 0.02,
  cbcCalcHomeGarden: 0.02,
  cbcCalcFoodDrink: 0.02,
  cbcCalcEntertainmentTech: 0.015,
  cbcCalcDaysOutGiftsHolidays: 0.02,
};

const calcCategoryOutput = (
  fieldValues: CategoryFields
): CalculationOutputCategory[] => {
  return categories.map((category) => {
    const currentCategorySpend = Number(fieldValues[category.id]);

    return {
      category: category.id,
      spend: currentCategorySpend,
      earnings: calcEarnings(
        currentCategorySpend,
        medianCategoryDiscounts[category.id]
      ),
      retailers: [],
    };
  });
};

export { calcCategoryOutput };
